import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

import { Header } from '../../../../../core/services/header';
import { dateFormatValidator, noFutureDateValidator, percentageValidator } from '../../../../../shared/utils/functions';
import { ARABIC_REGEX, ENGLISH_REGEX } from '../../../../../shared/utils/constants';
import { countries } from '../../../../../shared/utils/data';
import { InputField } from "../../../../../shared/ui/input-field/input-field";
import { CustomDropdown } from "../../../../../shared/components/custom-dropdown/custom-dropdown";
import { DatePicker } from "../../../../../shared/components/date-picker/date-picker";
import { Button } from "../../../../../shared/ui/button/button";

@Component({
  selector: 'app-corporate-owners',
  imports: [ReactiveFormsModule, InputField, TranslatePipe, CustomDropdown, DatePicker, Button],
  templateUrl: './corporate-owners.html',
  styleUrl: './corporate-owners.css'
})
export class CorporateOwners {
  @Input() data: any;
  @Output() formSubmit = new EventEmitter<any>();
  @Output() closeCurrentForm = new EventEmitter<any>();

  countriesOptions = countries;

  corporateOwnersForm = new FormGroup(
    {
      nationality: new FormControl('', [Validators.required]),

      corporateNameAr: new FormControl('', [Validators.required, Validators.pattern(ARABIC_REGEX)]),

      corporateNameEn: new FormControl('', [Validators.required, Validators.pattern(ENGLISH_REGEX)]),

      corporateShare: new FormControl('', [Validators.required, percentageValidator('corporateShare')]),

      dateOfEstablishment: new FormControl(null, [
        Validators.required,
        dateFormatValidator,
        noFutureDateValidator
      ]),
    }
  );

  constructor(private headerService: Header) {

  }

  ngOnInit(): void {
    //Set header configs
    this.headerService.updateConfig({
      title: 'Corporate owners',
      showNotifications: false,
      showRightSection: false,
      dropdownOptions: []
    });
  }

  ngOnDestroy() {
    this.headerService.resetConfig();
  }

  onDropdownSelect(controlName: string, selectedItem: any) {
    this.corporateOwnersForm.get(controlName)?.setValue(selectedItem.label);
  }

  getControl(controlName: string): FormControl {
    return this.corporateOwnersForm.get(controlName) as FormControl;
  }

  handleFormSubmission(formData: any) {
    // console.log("Received form data:", formData);
    this.formSubmit.emit(formData);
    //todo handle api calls
    this.closeCurrentForm.emit();
  }
}
